<template>
  <tr v-if="!isResponsive" :class="isHighlighted && 'highlight'">
    <td>
      <input
        type="checkbox"
        class="base-form-checkbox"
        name="lisans"
        :value="item.id"
        :data-value="itemParse"
        @change="loadPerspectiveSelect"
        :checked="check && 'checked'"
      />
    </td>
    <td>
      {{ seperateParanthesisFromTitle(item.name) }}
      <span v-if="paranthesisText != null" class="paranthesis">{{
        paranthesisText
      }}</span>
      <span v-if="item.shortContent">{{ item.shortContent }}</span>
    </td>
    <td>
      <div class="table-dropdown m-flex" v-if="isPerspectiveShow">
        <div class="info">
          <div class="info-option option" v-if="perspectiveData.length > 0">
            <package-setting-select
              ref="perspectiveSelect"
              :defaultValue="defaultPerspectiveID"
              :options="perspectiveData"
              @change="changePerspective"
              :class="paranthesisText != null ? 'mw-70' : ''"
            />
          </div>
        </div>
      </div>
      <div v-else class="text-center">-</div>
    </td>
    <td>
      <div class="table-dropdown m-flex" v-if="isDistributionShow">
        <div class="info">
          <div class="info-option option" v-if="distributionData.length > 0">
            <package-setting-select
              :key="uuid"
              :defaultValue="defaultVendorID"
              ref="distributionSelect"
              :options="distributionData"
              @change="changeDistribution"
            />
          </div>
        </div>
      </div>
      <div v-else class="text-center">-</div>
    </td>
    <td v-if="showSelectbox">
      <base-select
        fieldLabel="Başlangıç Zamanı"
        :options="startDate"
        id="startTime"
        @change="changeStartDate"
        :selectedId="startDateSelection"
        placeholder="Seçiniz"
        class="start-date-select"
      />
    </td>
    <td v-else>-</td>
  </tr>
  <div
    v-else
    class="responsive-table-container"
    :class="isHighlighted && 'highlight'"
  >
    <div class="mobile-wrap">
      <label class="row caption" :for="'input-' + item.marketId">
        <input
          type="checkbox"
          class="base-form-checkbox"
          name="lisans"
          :value="item.id"
          :data-value="itemParse"
          @change="loadPerspectiveSelect"
          :checked="check && 'checked'"
        />
        {{ seperateParanthesisFromTitle(item.name) }}
        <span v-if="paranthesisText != null" class="paranthesis">{{
          paranthesisText
        }}</span>
      </label>
      <div class="row">
        <span class="title">Derinlik</span>
        <div v-if="isPerspectiveShow">
          <div class="info-option option" v-if="perspectiveData.length > 0">
            <package-setting-select
              ref="perspectiveSelect"
              :defaultValue="defaultPerspectiveID"
              :options="perspectiveData"
              @change="changePerspective"
            />
          </div>
        </div>
        <div class="no-data" v-else>-</div>
      </div>
      <div class="row">
        <span class="title">Aracı Kurum Dağılımı</span>
        <div class="table-dropdown m-flex" v-if="isDistributionShow">
          <div class="info">
            <div class="info-option option" v-if="distributionData.length > 0">
              <package-setting-select
                :key="uuid"
                :defaultValue="defaultVendorID"
                ref="distributionSelect"
                :options="distributionData"
                @change="changeDistribution"
              />
            </div>
          </div>
        </div>
        <div class="no-data" v-else>-</div>
      </div>
      <div class="row">
        <span class="title">Başlangıç Zamanı</span>
        <base-select
          v-if="showSelectbox"
          fieldLabel="Başlangıç Zamanı"
          :options="startDate"
          id="startTime"
          @change="changeStartDate"
          :selectedId="startDateSelection"
          placeholder="Seçiniz"
          class="start-date-select"
        />
        <div class="no-data" v-else>-</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import PackageSettingSelect from "./PackageSettingSelect.vue";
import { BaseSelect } from "@/components";

export default {
  name: "PackageSettingType",
  components: {
    PackageSettingSelect,
    BaseSelect,
  },
  props: {
    dataItem: Object,
    selectData: Array,
    item: Object,
    isResponsive: Boolean,
  },

  data() {
    return {
      isHighlighted: false,
      perspectiveData: [],
      distributionData: [],
      packageFeatureSelected: {},
      isPerspectiveShow: false,
      isDistributionShow: false,
      uuid: new Date().getTime(),
      selectedMarketID: null,
      defaultPerspectiveID: null,
      defaultVendorID: null,
      filteredCheckCont: null,
      cusId: null,
      showSelectbox: false,
      startDateSelection: -1,
      paranthesisText: null,
      startDate: [
        {
          label: "Seçiniz",
          code: -1,
        },
        {
          label: "Hemen",
          code: 0,
        },
        {
          label: "Ay Başında",
          code: 1,
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["getPerspectiveInfo", "getDistributionInfo"]),
    itemParse() {
      return JSON.stringify(this.item);
    },
    check() {
      return this.dataItem.package.find(
        (o) => o.marketFeature.id === this.item.id
      );
    },
  },
  methods: {
    ...mapActions(["getPerspective", "getDistribution"]),
    checkCont() {
      this.filteredCheckCont = this.dataItem.package.find(
        (o) => o.marketFeature.id === this.item.id
      );
    },
    checkStartDateByRow() {
      const getStartDate = this.dataItem.package.find(
        (o) => o.marketFeature.id === this.item.id
      );
      if (getStartDate != undefined) {
        this.startDateSelection = Number(getStartDate.dateSelection.key);
        this.showSelectbox = true;
      }
    },
    checkFirstData() {
      if (this.check?.marketFeature.name == "Hisse + VİOP") {
        this.$emit("showSpesificWarning", true);
      }
    },
    seperateParanthesisFromTitle(title) {
      const getParanthesis = String(title).split("(");

      if (getParanthesis.length > 1) {
        this.paranthesisText = `${getParanthesis[1].replace(")", "")}`;
      }

      return getParanthesis[0];
    },
    getFirstData() {
      if (this.filteredCheckCont) {
        this.getPerspective([
          this.dataItem.application.applicationId,
          this.dataItem.platform.platformId,
          this.filteredCheckCont.marketFeature.marketId,
          this.cusId,
        ]).then((data) => {
          this.perspectiveData = data;
          this.loadDistributionSelect();

          this.defaultPerspectiveID =
            this.filteredCheckCont.perspectiveFeature?.id;
          this.defaultVendorID = this.filteredCheckCont.vendorFeature?.id;
          this.selectedMarketID = this.item.id;
          this.isPerspectiveShow = true;
          this.isHighlighted = true;
          this.fillData(
            this.item,
            this.filteredCheckCont.perspectiveFeature,
            this.filteredCheckCont.vendorFeature
          );
          this.checkSelectedData();
        });
      }
    },
    loadPerspectiveSelect(e) {
      const dataValue = JSON.parse(e.target.getAttribute("data-value"));
      if (this.isPerspectiveShow) this.isPerspectiveShow = false;
      if (this.isDistributionShow) this.isDistributionShow = false;
      this.isHighlighted = false;
      if (e.target.checked) {
        this.isHighlighted = true;
        this.showSelectbox = true;
        this.getPerspective([
          dataValue.applicationId,
          dataValue.platformId,
          dataValue.marketId,
          this.cusId,
        ]).then(async (data) => {
          await this.getDistribution([
            dataValue.applicationId,
            dataValue.platformId,
            dataValue.marketId,
            this.cusId,
          ]);
          if (this.getPerspectiveInfo.length > 0) {
            this.perspectiveData = data;
            this.distributionData = this.getDistributionInfo;
            this.selectedMarketID = e.target.value;
            this.defaultPerspectiveID = null;
            this.isPerspectiveShow = true;
            this.fillData(
              dataValue,
              this.perspectiveData[0],
              this.distributionData[0]
            );
            this.checkSelectedData();
          } else {
            this.fillData(dataValue, null);
            this.checkSelectedData();
          }
        });
        this.loadDistributionSelect(dataValue);
        if (dataValue.name === "Hisse + VİOP") {
          this.$emit("showSpesificWarning", true);
        }
      } else {
        this.showSelectbox = false;
        if (dataValue.name === "Hisse + VİOP") {
          this.$emit("showSpesificWarning", false);
        }
        this.$emit(
          "update",
          this.selectData.filter(
            (item) => item?.marketFeature?.id !== dataValue.id
          )
        );
      }
    },
    loadDistributionSelect(dataVal = null) {
      this.getDistribution([
        dataVal?.applicationId || this.dataItem.application.applicationId,
        dataVal?.platformId || this.dataItem.platform.platformId,
        dataVal?.marketId || this.filteredCheckCont.marketFeature.marketId,
        this.cusId,
      ]).then((data) => {
        if (this.getDistributionInfo.length > 0) {
          this.distributionData = data;
          this.isDistributionShow = true;
          this.showSelectbox = true;
        }
      });
    },
    changeStartDate(value) {
      this.startDateSelection = value.code;
      this.packageFeatureSelected.dateSelection = value.code;
      this.checkSelectedData();
    },
    changePerspective(value) {
      this.uuid = new Date().getTime();
      this.packageFeatureSelected.perspectiveFeature = value;
      this.checkSelectedData();
    },
    changeDistribution(value) {
      this.packageFeatureSelected.vendorFeature = value;
      this.defaultVendorID = value.id;
      this.checkSelectedData();
    },
    fillData(marketFeature, perspectiveFeature, vendorFeature = {}) {
      this.packageFeatureSelected.packageId = this.dataItem.id;
      this.packageFeatureSelected.marketFeature = marketFeature;
      this.packageFeatureSelected.platformFeature = this.dataItem.platform;
      this.packageFeatureSelected.perspectiveFeature = perspectiveFeature;
      this.packageFeatureSelected.vendorFeature = vendorFeature;
      this.packageFeatureSelected.dateSelection = this.startDateSelection;
    },
    checkSelectedData() {
      if (!this.packageFeatureSelected.marketFeature) return;
      const findData = this.selectData.find((item) => {
        return (
          item?.marketFeature?.id ===
          this.packageFeatureSelected.marketFeature.id
        );
      });
      if (findData) {
        const newData = { ...findData, ...this.packageFeatureSelected };
        const lastData = this.selectData.map((item) => {
          if (item.marketFeature.id === newData.marketFeature.id) {
            return newData;
          }
          return item;
        });
        this.$emit("update", lastData);
      } else {
        this.selectData.push(this.packageFeatureSelected);
        this.$emit("update", this.selectData);
      }
    },
  },
  mounted() {
    if (this.$route.params.customerId !== undefined) {
      this.cusId = this.$route.params.customerId;
    }
    this.checkCont();
    this.checkStartDateByRow();
    this.getFirstData();
    this.checkFirstData();
  },
};
</script>

<style lang="scss">
.start-date-select {
  width: 100%;
}
.osm-vd {
  .popup-right {
    .option {
      .veri-dagitim-selectbox.v-select {
        .vs__dropdown-toggle {
          justify-content: space-between;
          min-width: auto;
          width: 270px;
          @media (max-width: 768px) {
            width: auto !important;
          }
        }
        .vs__selected-options {
          padding: 0;
        }
        .vs__actions {
          margin-right: 0px;
        }
      }
    }
  }
}
</style>
